module.exports = __webpack_public_path__ + "img/arrow-up.f80a606f.svg";